<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/coinPrice/pledgeGasDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
    <div class="searchLeft">
      <p style="margin-left:20px;display:inline-block;">
        <span>最少Gas：</span>
        <span style="color:red;font-size:20px;">{{configData&&configData.minGas?configData.minGas+' FIL':0}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>Gas上浮部分：</span>
        <span style="color:red;font-size:20px;">{{configData&&configData.riseGas?configData.riseGas+' FIL':0}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>成本上浮比率：</span>
        <span style="color:red;font-size:20px;">{{configData&&configData.riseCost?configData.riseCost+' %':0}} </span>
      </p>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="browserPledge"
      label="浏览器质押">
    </el-table-column>
    <el-table-column
      prop="browserGas"
      label="浏览器Gas">
    </el-table-column>
    <el-table-column
      prop="salePledge"
      label="销售质押">
    </el-table-column>
    <el-table-column
      prop="saleGas"
      label="销售Gas">
    </el-table-column>
    <el-table-column
      prop="dataDate"
      label="数据时间">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间">
    </el-table-column>
    <!-- <el-table-column
      fixed="right"
      width="100px"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="goDetl(scope.row.id)"><i class="el-icon-view" style="margin-right:3px;"></i>每日收益</el-button>
      </template>
    </el-table-column> -->
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        searchContent: '',
        startTime: '',
        endTime: '',
        miningStatus: 0
      },
      tableData: [],
      options: [
        { name: "全部", value: 0 },
        { name: "服务中", value: 1 },
        { name: "待服务", value: 2 },
        { name: "已结束", value: 3 },
      ],
      userId: '',
      balance: 0,
      balanceTwo: 0,
      url: window.g.host,
      configData: null
    };
  },
  created() {
    this.getTableList()
    this.getConfig()
  },
  methods: {
    async getConfig(){
      let res = await this.$http.pledgeGasConfig();
      if (res) {
        console.log(res)
        this.configData = res.data
      }
      
    },
    goDetl(id) {
      this.$router.push({name:'orderIncomeDaily',query:{orderId:id}})
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.pledgeGasDailyList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
